import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFuelVendors = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendors fetch error:", error);
    throw error;
  }
};

const getVendorById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor fetch error:", error);
    throw error;
  }
};

const updateVendorDetails = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/?id=${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor update error:", error);
    throw error;
  }
};

const getFuelTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/fuel-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel types lookup error:", error);
    throw error;
  }
};

const payVendorSettlement = async (id, formData) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/settlements/?id=${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor settlement payment error:", error);
    throw error;
  }
};

const initiateWiPaySettlement = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/settlements/wipay/initiate/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("WiPay settlement initiate error:", error);
    throw error;
  }
};

const getPayableTransactions = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-vendors/settlements/payable-transactions/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Payable transactions fetch error:", error);
    throw error;
  }
};

const deleteVendorDocument = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}documents/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Document delete error:", error);
    throw error;
  }
};

export {
  getFuelVendors,
  getVendorById,
  updateVendorDetails,
  getFuelTypes,
  payVendorSettlement,
  initiateWiPaySettlement,
  getPayableTransactions,
  deleteVendorDocument,
};
